import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import OfferPageContainer from './OfferPageContainer';
import actions from './OfferPageContainer.actions';
import linkActions from '../OfferPagePromoLinks/OfferPagePromoLinks.actions';
import {
    getLoading,
    isEmpty,
    isPaused
} from './OfferPageContainer.selectors';
import promoCodeActions from "../../../../actions/PromoCodeActions";

const mapStateToPropsSelectors = createStructuredSelector({
    loading: getLoading,
    isEmpty: isEmpty,
    isPaused: isPaused
});

const OfferPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routing.locationBeforeTransitions,
            offer: state.offers.list[0] || {}
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            searchGoalEntries: actions.searchGoalEntries,
            searchLinks: linkActions.getLinks,
            saveLinkPresets: linkActions.saveLinkPresets,
            savePromoCode: promoCodeActions.savePromoCode,
            validatePromoCode: promoCodeActions.validatePromoCode,
            editPromoCode: promoCodeActions.editPromoCode,
        };
    }
)(withRouter(OfferPageContainer));

export default OfferPageContainerComponent;
